import position from "../../styles/position";

export default {
    table: {
        width: "100%",
        height: "100%"
    } as React.CSSProperties,
    header: {
        height: 1
    } as React.CSSProperties,
    contentWrapper: {
        position: "relative",
        height: "100%",
        verticalAlign: "top"
    } as React.CSSProperties,
    content: {
        ...position.absoluteFill,
        overflow: "auto"
    }

}